import React, { useState } from 'react';

export default function ProdutoForm({ onSubmit, onCancel }) {
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [quantidade, setQuantidade] = useState(0);
  const [precoCusto, setPrecoCusto] = useState('');
  const [precoVenda, setPrecoVenda] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nome.trim()) return;
    onSubmit({
      nome: nome.trim(), descricao: descricao.trim(),
      quantidade: Number(quantidade) || 0,
      preco_custo: parseFloat(precoCusto) || 0,
      preco: parseFloat(precoVenda) || 0,
    });
  };

  return (
    <form className="fm" onSubmit={handleSubmit}>
      <input className="inp" placeholder="Nome *" value={nome} onChange={e => setNome(e.target.value)} required />
      <input className="inp" placeholder="Descrição" value={descricao} onChange={e => setDescricao(e.target.value)} />
      <input className="inp" type="number" placeholder="Qtd inicial" min={0} value={quantidade} onChange={e => setQuantidade(e.target.value)} />
      <div className="inp-r">
        <input className="inp" type="number" step="0.01" placeholder="Custo R$" value={precoCusto} onChange={e => setPrecoCusto(e.target.value)} />
        <input className="inp" type="number" step="0.01" placeholder="Venda R$" value={precoVenda} onChange={e => setPrecoVenda(e.target.value)} />
      </div>
      <div className="btn-g">
        <button className="btn btn1" type="submit">Salvar</button>
        <button className="btn btn3" type="button" onClick={onCancel}>Cancelar</button>
      </div>
    </form>
  );
}
